export default __webpack_public_path__ + "static/media/eye2.3bf64207.png";